
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import PopLayout from '../layout/index.vue'
import UserContent from '../content/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'

@Observer
@Component({
  components: { PopLayout, UserContent }
})
export default class PopUserContent extends Vue {
  @Prop({ default: false }) toggleHide: boolean

  visible = false

  // 用户内容详情弹窗
  userContentOptions: HomeworkOption | DairyOption | null = null

  // 暴露给父组件
  showPop(options: HomeworkOption | DairyOption) {
    this.userContentOptions = options
    this.visible = true
  }

  // 暴露给父组件
  hidePop() {
    this.visible = false
  }

  handleClickBack() {}

  handleToggleVisibleSuccess(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    if (this.toggleHide === true) {
      this.handleRemoveContentSuccess(data)
    }
  }

  handleRemoveContentSuccess(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    this.$emit('remove-success', data)

    if (data.type === 'dairy') {
      this.hidePop()
    }
  }

  handleLikeSuccess(data: { momentId: string }) {
    this.$emit('like-success', data)
  }

  handleFollowSuccess(data: boolean) {
    this.$emit('follow-success', data)
  }

  handleClosed() {
    this.userContentOptions = null
    this.$store.$courseV2.UserContent.reset()
    this.$emit('closed')
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
